import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'

import { AuthenticationContext, EntitySettingsContext } from '../../Contexts'
import { Property } from '../Property'

type EntityType = 'User' | 'Admin'

const EntityTypeProperty: React.FC = () => {
  const entitySettings = useContext(EntitySettingsContext)
  const { authEntity } = useContext(AuthenticationContext)
  const isAdmin = !!entitySettings?.data._admin
  const entityType = entitySettings?.data ? (isAdmin ? 'Admin' : 'User') : undefined

  const onChange = async (event: SelectChangeEvent<EntityType>) => {
    const value = event.target.value as EntityType
    await entitySettings?.setAdmin(value === 'Admin')
  }

  return (
    <Property tip="The entity type" title="Entity  Type" value={entityType}>
      <Select<EntityType> disabled={authEntity?.admin !== true ?? true} onChange={onChange} value={entityType} variant="standard">
        <MenuItem value={'User'}>User</MenuItem>
        <MenuItem value={'Admin'}>Admin</MenuItem>
      </Select>
    </Property>
  )
}

export default EntityTypeProperty
